<doc>
	This is for injecting Icon sprite into the app.vue to using globally.
</doc>

<template>
	<svg id="icons" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" viewBox="0 0 36 36">
		<defs>
			// Third party account providers //
			<symbol id="icon-local-ext-facebook" viewBox="0 0 30 30">
				<g clip-path="url(#clip0_38_354)">
					<path
						d="M27 14.5459C27 7.61706 21.4035 2 14.5 2C7.5965 2 2 7.61706 2 14.5459C2 20.4295 6.036 25.3665 11.4805 26.7225V18.3799H8.903V14.5459H11.4805V12.8939C11.4805 8.62374 13.406 6.6445 17.583 6.6445C18.375 6.6445 19.7415 6.80057 20.3005 6.95614V10.4314C20.0055 10.4002 19.493 10.3847 18.8565 10.3847C16.807 10.3847 16.015 11.164 16.015 13.19V14.5459H20.098L19.3965 18.3799H16.015V27C22.2045 26.2498 27.0005 20.9604 27.0005 14.5459H27Z"
						fill="white"
					/>
				</g>
				<defs>
					<clipPath id="clip0_38_354">
						<rect width="25" height="25" fill="white" transform="translate(2 2)" />
					</clipPath>
				</defs>
			</symbol>
			<symbol id="icon-local-ext-tiktok" class="white" viewBox="0 0 30 30">
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M16.3069 4.04712H19.3378C19.63 5.61914 20.5662 6.96806 21.8633 7.81082L21.8646 7.81244C22.7676 8.3989 23.8441 8.74106 24.9999 8.74106V9.65954L25 12.8665C22.8532 12.8665 20.8639 12.182 19.2402 11.0205V19.4055C19.2402 23.5932 15.8218 27 11.6199 27C9.99635 27 8.49068 26.4897 7.25303 25.6236L7.25091 25.6214C5.28702 24.2463 4 21.9732 4 19.4047C4 15.2172 7.41833 11.8102 11.6202 11.8102C11.9688 11.8102 12.3106 11.8388 12.647 11.8843V12.8618L12.6469 16.0973C12.3218 15.996 11.9782 15.937 11.6199 15.937C9.70106 15.937 8.13994 17.4931 8.13994 19.4055C8.13994 20.7373 8.89807 21.8944 10.0057 22.4753C10.4887 22.7287 11.0373 22.8739 11.6198 22.8739C13.4945 22.8739 15.0237 21.3877 15.0933 19.536L15.1 3H19.24C19.24 3.35768 19.2747 3.70726 19.3378 4.04712H16.3069Z"
					fill="white"
				/>
			</symbol>
			<symbol id="icon-local-ext-x" class="white" viewBox="0 0 30 30">
				<path
					d="M16.9027 12.8921L24.3482 4H22.5838L16.119 11.7209L10.9555 4H5L12.8082 15.6753L5 25H6.76443L13.5915 16.8465L19.0445 25H25L16.9023 12.8921H16.9027ZM14.4861 15.7782L13.695 14.6156L7.40018 5.36466H10.1102L15.1902 12.8304L15.9813 13.993L22.5847 23.6974H19.8746L14.4861 15.7786V15.7782Z"
					fill="white"
				/>
			</symbol>
			<symbol id="icon-local-ext-twitch" class="white" viewBox="0 0 30 30">
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M17.6927 24.0998H14.3089L10.0774 28.2526V24.0998H5V9.15277L9.23146 5H25.3081V16.6255L17.6927 24.0998ZM23.6161 6.66078H10.0774V19.1158H13.8843V22.0226L16.8468 19.1158H20.2306L23.6161 15.7942V6.66078ZM19.3863 9.56755H21.0766V14.5499H19.3863V9.56755ZM14.7319 9.56755H16.4238V14.5499H14.7319V9.56755Z"
					fill="white"
				/>
			</symbol>
			<symbol id="icon-local-ext-instagram" class="white" viewBox="0 0 30 30">
				<path
					d="M9.73712 3.08055C8.51352 3.13828 7.67793 3.33355 6.94745 3.62059C6.19144 3.91522 5.55066 4.31059 4.9131 4.95045C4.27554 5.59031 3.88293 6.23155 3.59037 6.98871C3.30724 7.7208 3.11542 8.55708 3.06137 9.78137C3.00732 11.0057 2.99536 11.3992 3.00134 14.5221C3.00732 17.6451 3.02112 18.0365 3.08046 19.2633C3.13888 20.4867 3.33346 21.3221 3.6205 22.0528C3.91559 22.8088 4.3105 23.4494 4.95059 24.0871C5.59068 24.7249 6.23146 25.1166 6.99046 25.4096C7.72186 25.6923 8.55837 25.8851 9.78243 25.9386C11.0065 25.9922 11.4005 26.0047 14.5225 25.9987C17.6445 25.9927 18.0376 25.9789 19.2642 25.9207C20.4908 25.8625 21.3218 25.6666 22.0527 25.3809C22.8087 25.0851 23.4497 24.6909 24.087 24.0506C24.7244 23.4102 25.1168 22.7686 25.4091 22.0109C25.6924 21.2795 25.885 20.443 25.9381 19.2199C25.9917 17.9924 26.0043 17.6005 25.9983 14.478C25.9924 11.3555 25.9783 10.964 25.9201 9.73767C25.862 8.51131 25.6671 7.67848 25.3803 6.94731C25.0848 6.1913 24.6903 5.55121 24.0505 4.91296C23.4106 4.27471 22.7685 3.88256 22.0111 3.59092C21.2792 3.30779 20.4432 3.11482 19.2191 3.06192C17.995 3.00902 17.601 2.99545 14.4779 3.00143C11.3547 3.00741 10.9637 3.02075 9.73712 3.08055ZM9.87144 23.8698C8.75019 23.821 8.14138 23.6347 7.73566 23.4788C7.19838 23.2718 6.81566 23.0216 6.41132 22.6211C6.00698 22.2207 5.75858 21.8366 5.54882 21.3005C5.39127 20.8947 5.20152 20.2866 5.14908 19.1654C5.09204 17.9535 5.08008 17.5896 5.07341 14.5194C5.06674 11.4491 5.07847 11.0857 5.1316 9.87337C5.17944 8.75304 5.36689 8.14354 5.5226 7.73805C5.7296 7.20008 5.97892 6.81805 6.38027 6.41394C6.78162 6.00983 7.16457 5.76097 7.70116 5.55121C8.10642 5.39297 8.71454 5.20483 9.83533 5.15147C11.0481 5.09397 11.4115 5.08247 14.4813 5.0758C17.5511 5.06913 17.9155 5.08063 19.1287 5.13399C20.249 5.18275 20.8588 5.36836 21.2638 5.52499C21.8013 5.73199 22.1838 5.98062 22.5879 6.38266C22.992 6.7847 23.2411 7.16627 23.4509 7.70401C23.6093 8.10812 23.7975 8.71601 23.8504 9.83749C23.9081 11.0503 23.9212 11.4139 23.9267 14.4835C23.9323 17.5531 23.9214 17.9176 23.8683 19.1295C23.8193 20.2507 23.6335 20.8598 23.4773 21.266C23.2703 21.803 23.0208 22.186 22.6192 22.5898C22.2176 22.9937 21.8351 23.2426 21.2983 23.4523C20.8935 23.6103 20.2847 23.799 19.1648 23.8523C17.952 23.9094 17.5886 23.9213 14.5177 23.928C11.4467 23.9347 11.0845 23.9222 9.87167 23.8698M19.2465 8.35376C19.2469 8.62672 19.3283 8.89341 19.4804 9.12011C19.6324 9.3468 19.8482 9.52332 20.1006 9.62733C20.353 9.73135 20.6305 9.75819 20.8981 9.70446C21.1657 9.65073 21.4114 9.51884 21.6041 9.32547C21.7967 9.13211 21.9277 8.88596 21.9805 8.61814C22.0332 8.35033 22.0053 8.07289 21.9004 7.82091C21.7955 7.56893 21.6182 7.35373 21.3909 7.20253C21.1637 7.05133 20.8967 6.97091 20.6237 6.97146C20.2578 6.97219 19.9071 7.11822 19.6489 7.37744C19.3906 7.63666 19.2459 7.98784 19.2465 8.35376ZM8.59517 14.5116C8.60161 17.773 11.2503 20.4108 14.511 20.4046C17.7717 20.3984 20.4114 17.75 20.4052 14.4886C20.399 11.2271 17.7496 8.58859 14.4885 8.59503C11.2273 8.60147 8.58896 11.2506 8.59517 14.5116ZM10.6665 14.5074C10.665 13.7492 10.8884 13.0076 11.3084 12.3764C11.7284 11.7452 12.3261 11.2527 13.026 10.9611C13.7259 10.6696 14.4965 10.5922 15.2404 10.7386C15.9843 10.885 16.668 11.2488 17.2052 11.7838C17.7424 12.3189 18.1088 13.0012 18.2582 13.7445C18.4076 14.4878 18.3332 15.2588 18.0445 15.9598C17.7557 16.6608 17.2656 17.2605 16.636 17.683C16.0064 18.1054 15.2657 18.3317 14.5075 18.3332C14.0041 18.3343 13.5054 18.2362 13.0399 18.0445C12.5744 17.8528 12.1512 17.5712 11.7946 17.216C11.4379 16.8607 11.1547 16.4386 10.9611 15.9739C10.7676 15.5092 10.6675 15.0108 10.6665 14.5074Z"
					fill="white"
				/>
			</symbol>
			<symbol id="icon-local-ext-youtube" class="white" viewBox="0 0 30 30">
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M26.2839 5.59677C27.5048 5.92581 28.4677 6.89355 28.7936 8.12258C29.3871 10.3516 29.3871 15 29.3871 15C29.3871 15 29.3871 19.65 28.7936 21.8774C28.4677 23.1065 27.5048 24.0742 26.2839 24.4032C24.071 25 15.1936 25 15.1936 25C15.1936 25 6.31774 25 4.10323 24.4032C2.88226 24.0742 1.91935 23.1065 1.59355 21.8774C1 19.6484 1 15 1 15C1 15 1 10.3516 1.59355 8.12258C1.91935 6.89355 2.88226 5.92581 4.10323 5.59677C6.31613 5 15.1936 5 15.1936 5C15.1936 5 24.071 5 26.2839 5.59677ZM19.7096 15.0003L12.2902 10.7793V19.2212L19.7096 15.0003Z"
					fill="white"
				/>
			</symbol>
			<symbol id="icon-local-ext-discord" class="white" viewBox="0 0 30 30">
				<path
					d="M23.9493 6.68775C26.8731 11.0427 28.3171 15.9549 27.7773 21.61C27.775 21.6339 27.7627 21.6559 27.7433 21.6703C25.5292 23.3173 23.384 24.3169 21.2689 24.9798C21.2524 24.9848 21.2348 24.9845 21.2185 24.979C21.2022 24.9734 21.188 24.9628 21.1779 24.9486C20.6893 24.2598 20.2453 23.5337 19.8563 22.7712C19.834 22.7262 19.8544 22.6722 19.9003 22.6545C20.6055 22.3853 21.276 22.0627 21.921 21.6808C21.9718 21.6506 21.975 21.5769 21.9281 21.5415C21.7912 21.4385 21.6556 21.3303 21.5258 21.2222C21.5016 21.2022 21.4689 21.1982 21.4414 21.2117C17.2542 23.1705 12.6674 23.1705 8.43066 21.2117C8.40316 21.1992 8.37047 21.2035 8.34685 21.2231C8.2174 21.3313 8.08149 21.4385 7.9459 21.5415C7.89897 21.5769 7.90286 21.6506 7.95399 21.6808C8.59894 22.0555 9.26946 22.3853 9.97363 22.6558C10.0193 22.6735 10.0409 22.7262 10.0183 22.7712C9.63772 23.5347 9.19373 24.2608 8.69602 24.9496C8.67434 24.9775 8.63874 24.9903 8.60509 24.9798C6.50001 24.3169 4.35481 23.3173 2.14067 21.6703C2.12223 21.6559 2.10896 21.6329 2.10702 21.609C1.65591 16.7174 2.57528 11.7645 5.93143 6.68676C5.93952 6.67332 5.95182 6.66283 5.96606 6.6566C7.61743 5.88882 9.3866 5.32397 11.2357 5.00138C11.2694 4.99614 11.303 5.01187 11.3205 5.04203C11.549 5.45182 11.8101 5.97734 11.9868 6.4068C13.9359 6.10519 15.9154 6.10519 17.9053 6.4068C18.082 5.98652 18.3341 5.45182 18.5616 5.04203C18.5697 5.02707 18.5822 5.01508 18.5975 5.00778C18.6127 5.00048 18.6298 4.99824 18.6464 5.00138C20.4964 5.32495 22.2656 5.88981 23.9157 6.6566C23.9302 6.66283 23.9422 6.67332 23.9493 6.68775ZM12.9777 15.9883C12.9981 14.5423 11.9574 13.3457 10.6509 13.3457C9.35521 13.3457 8.32452 14.5318 8.32452 15.9883C8.32452 17.4446 9.3756 18.6306 10.6509 18.6306C11.947 18.6306 12.9777 17.4446 12.9777 15.9883ZM21.5799 15.9883C21.6003 14.5423 20.5595 13.3457 19.2534 13.3457C17.9574 13.3457 16.9267 14.5318 16.9267 15.9883C16.9267 17.4446 17.9778 18.6306 19.2534 18.6306C20.5595 18.6306 21.5799 17.4446 21.5799 15.9883Z"
					fill="white"
				/>
			</symbol>
			<symbol id="icon-local-homepage" class="white" viewBox="0 0 15 15">
				<path d="M6.2 13V9.11765H8.8V13H12.05V7.82353H14L7.5 2L1 7.82353H2.95V13H6.2Z" fill="white" />
			</symbol>
			<symbol id="icon-local-ext-community" class="white" viewBox="0 0 15 15">
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M12.45 4.17546H11.3492V9.07099H4.2V10.1595C4.2 10.4586 4.44777 10.7026 4.75 10.7026H10.7992L13 12.8796V4.72009C13 4.42092 12.7515 4.17546 12.45 4.17546ZM10.25 7.4394V2.54387C10.2486 2.39913 10.1901 2.26081 10.0872 2.15897C9.9844 2.05712 9.84551 2 9.70077 2H2.55077C2.40576 1.99959 2.26648 2.05654 2.1633 2.15842C2.06012 2.26031 2.00142 2.39887 2 2.54387V10.1595L4.2 7.98403H9.70077C10.0022 7.98403 10.25 7.73857 10.25 7.4394Z"
					fill="white"
				/>
			</symbol>
		</defs>
	</svg>
</template>

<script>
export default {
	name: 'IconSprite',
};
</script>

<style scoped>
.cls-1 {
	fill: #fff;
}
.cls-2 {
	fill: #00a1df;
}
.cls-3 {
	fill: #003da6;
}
.cls-4 {
	fill: #c4d600;
}
.highlight {
	fill: #17e5c3;
}
.facebook-bg-blue {
	fill: #3b579d;
}
.steam-gray {
	fill: #464646;
}
.white,
.facebook-bg {
	fill: #fff;
}
.facebook-f {
	fill: #3b5998;
}
.wordmark-google {
	fill: #706f70;
}
.black {
	fill: #000;
}
.hover {
	fill: #00decb;
}
.light-blue {
	fill: #00aaff;
}
.ellipsis {
	fill: #808080;
}
.ellipsis-active {
	fill: #ffffff;
}
.icon-btn {
	fill: #202020;
}
.icon-btn-hover {
	fill: #0077ff;
}
.thick-x-default {
	fill: #bebebe;
}
.thick-x-hover {
	fill: #e5e5e5;
}
.thick-x-press {
	fill: #666666;
}
.btn-play {
	opacity: 0.5;
}
.btn-play-hover {
	fill: #07f;
}
.warning-dark {
	fill: #242424;
}
</style>
